import { BookOpen } from 'lucide-react';
import type { ModuleMeta } from '../types';

export const meta: ModuleMeta = { id: 'guides', label: 'Guides', route: '/guides', icon: BookOpen };
